import React from 'react';
import { useQuery } from 'react-query';
import { SaveUserDashboardRequest, UserDashboardDto } from './api';
import useApi from './useApi';

export const USER_DASHBOARDS_KEY = 'user-dashboards';

export const useUserDashboardsQuery = (projectId: string) => {
  const api = useApi();

  return useQuery(
    [USER_DASHBOARDS_KEY, projectId],
    () => api.userDashboards.getMyDashboards(projectId),
    { staleTime: Infinity, refetchOnWindowFocus: false, enabled: !!projectId },
  );
};

export interface UserDashboardClient {
  save: (request: SaveUserDashboardRequest) => Promise<UserDashboardDto>;
  remove: (dashboardId: string) => Promise<void>;
}

// Plain promises, not useMutation: the global MutationCache would snackbar every failed retry.
export const useUserDashboardClient = (projectId: string): UserDashboardClient => {
  const api = useApi();

  return React.useMemo(() => ({
    save: (request: SaveUserDashboardRequest) => api.userDashboards.saveMyDashboard(projectId, request),
    remove: (dashboardId: string) => api.userDashboards.deleteMyDashboard(projectId, dashboardId),
  }), [api, projectId]);
};
